// Third party
import React from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  disabled?: boolean;
  label: React.ReactNode;
  content?: React.ReactNode;
  warning?: React.ReactNode;
  children?: React.ReactNode;
  nonClickable?: boolean;
};

const ComparisonTopBarBaseMenuItem = ({ className, onClick, disabled = false, label, content, warning, children, nonClickable = false }: Props) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!disabled && !nonClickable && onClick) {
      onClick(e);
    }
  };

  const classes = classNames('comparison-menu-item', className, {
    disabled,
    'non-clickable': nonClickable,
  });

  return (
    <div className={classes} onClick={handleClick} role={nonClickable ? undefined : 'button'} tabIndex={disabled || nonClickable ? -1 : 0}>
      <div className="menu-item-label">{label}</div>
      {content && <div className="menu-item-content">{content}</div>}
      {warning && <div className="menu-item-warning">{warning}</div>}
      {children}
    </div>
  );
};

export default ComparisonTopBarBaseMenuItem;
